import { render, staticRenderFns } from "./add.vue?vue&type=template&id=12bbc15e&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style1 from "./add.vue?vue&type=style&index=1&id=12bbc15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbc15e",
  null
  
)

export default component.exports